import { BlogsPage } from "./Blogs";
export default BlogsPage;
